// (C) Copyright 2015 Hewlett Packard Enterprise Development LP
import constants from '../Constants';
export function filterChart(chartData, chartOptions) {
  for (let key in chartData) {
    /**display options */
    chartData[key] = chartOptions.displayOptions[key] ? chartData[key] : null;
    /*** */
    /**Depth */

    for (let depthKey in chartData[key]) {
      let lastLetter = depthKey.substr(depthKey.length - 1, 1);
      if (lastLetter === ")") {
        lastLetter = depthKey.substr(depthKey.length - 2, 1);
      }
      if (isNaN(lastLetter)) {
        lastLetter = extractDisplayOptionIndex(depthKey);
      }

      if (depthKey.search('onboard') == -1) {
        chartData[key][depthKey] = chartOptions.depth[lastLetter] ? chartData[key][depthKey] : []
      }
    }
  }
  return chartData
}

function extractDisplayOptionIndex(depthKey) {
  let deptOptions = ['top', 'middle', 'bottom'];
  let selectedIndex = -2;
  for (let index = 0; index < deptOptions.length; index++) {
    if (depthKey.toLowerCase().indexOf(deptOptions[index]) > -1) {
      selectedIndex = index;
      break;
    }
  }
  return selectedIndex + 1;
}

export function saveInSession(key, value) {
  sessionStorage[key] = JSON.stringify(value);
}
export function getFromSession(key) {
  if (sessionStorage[key]) {
    return JSON.parse(sessionStorage[key]);
  } else {
    return false;
  }
}
export function getMapCenter() {
  let postionObj = {}

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition((position) => {
      postionObj = {
        lat: position.coords.latitude, lng: position.coords.longitude
      }
      return postionObj;
    });
  }
}

export function checkForNumber(val) {

  var re = /^([0-9]+[\.]?[0-9]?[0-9]?|[0-9]+)$/g;
  var re1 = /^([0-9]+[\.]?[0-9]?[0-9]?|[0-9]+)/g;
  if (re.test(val) || val == '') {
    return true;
  } else {
    return false;
  };
}

export function loadTwigDataBasedonPreference(state, payload) {
  let twigIndex = 0, selectedTwig = [];
  //payload.userPreferences.preference.stem
  state.twigsList.map((twig, index) => {
    if (twig.twigId == payload.UserPref.preference.stem) {
      selectedTwig = twig;
      twigIndex = index;
    }
  });

  let DateRange = getDateFromDateRange(payload.UserPref.dateRange);
  return {
    twigIndex: twigIndex, selectedTwig: selectedTwig,
    DateRange: {
      type: payload.UserPref.preference.dateRange,
      fromDate: payload.UserPref.preference.fromDate,
      toDate: payload.UserPref.preference.toDate
    },
    Depth: {
      [constants.CHART_OPTIONS.TOP]: payload.UserPref.preference.depth[constants.CHART_OPTIONS.TOP],
      [constants.CHART_OPTIONS.MIDDLE]: payload.UserPref.preference.depth[constants.CHART_OPTIONS.MIDDLE],
      [constants.CHART_OPTIONS.BOTTOM]: payload.UserPref.preference.depth[constants.CHART_OPTIONS.BOTTOM]
    }
  };
}

export function getDateFromDateRange(value) {
  // let value = e.target.value;
  let fromDate = '';
  let now = new Date();
  let toDate = now.getTime();
  switch (value) {
    case constants.DATE_RANGE.ALL:
      fromDate = '';
      break;
    case constants.DATE_RANGE.CUSTOM:
      fromDate = false;
      break;
    case constants.DATE_RANGE.LAST_HOUR:
      fromDate = now.setHours(now.getHours() - 1);
      break;
    case constants.DATE_RANGE.LAST_SIX_HOURS:
      fromDate = now.setHours(now.getHours() - 6);
      break;
    case constants.DATE_RANGE.ONE_DAY:
      fromDate = now.setHours(now.getHours() - 24);
      break;
    case constants.DATE_RANGE.ONE_TO_ELEVAN_MONTHS:
      fromDate = now.setMonth(now.getMonth() - 11);
      break;
    case constants.DATE_RANGE.ONE_WEEK:
      fromDate = now.setDate(now.getDate() - 7);
      break;
    case constants.DATE_RANGE.ONE_YEAR:
      fromDate = now.setYear(now.getFullYear() - 1);
      break;
    case constants.DATE_RANGE.TWO_WEEKS:
      fromDate = now.setDate(now.getDate() - 14);
      break;
    case constants.DATE_RANGE.ONE_MONTH:
      fromDate = now.setMonth(now.getMonth() - 1);
      break;
    case constants.DATE_RANGE.SIX_MONTHS:
      fromDate = now.setMonth(now.getMonth() - 6);
      break;

    default:
      break;
  }

  return { fromDate: fromDate, toDate: toDate };
}

export function getInitialFromDate() {
  let now = new Date();
  let fromDate = now.setDate(now.getDate() - 14);
  return fromDate;
}

export function getSelectedTwigDetails(twigId, twigList) {
  let filteredTwig = [], displayOption = {};
  filteredTwig = twigList.filter(function (twig) {
    return twig.twigId === twigId
  });
  if (filteredTwig.length > 0) {
    Object.keys(filteredTwig[0].details.data).map((key, index) => {
      displayOption[key] = true;
    });
    return displayOption;
  } else {
    return {};
  }
}

export function convertToISO(input) {
  if(input  && typeof(input) === "number"){
    input = new Date(input).toISOString();
  }
  if (input && input.length > 0) {
    let newDate = '';
    try {
      let arr = input.split('/');
      if (arr.length === 1) {
        newDate = convertDate(input);
        if (newDate.length > 0) {
          let arrDate = newDate.split('/');
          if (arrDate.length > 1) {
            let finalDate = new Date(arrDate[2], arrDate[0] - 1, arrDate[1], 12).toISOString();
            return finalDate;
          } else {
            return arrDate[0];
          }
        }
      } else {
        newDate = new Date(arr[2], arr[0] - 1, arr[1], 12).toISOString();
      }
      return newDate;
    } catch (error) {
      return '';
    }
  } else {
    return '';
  }
}

export function convertDate(inputFormat) {
  function pad(s) { return (s < 10) ? '0' + s : s; }
  try {
    if (inputFormat) {
      var d = new Date(inputFormat);
      return [pad(d.getMonth() + 1), pad(d.getDate()), d.getFullYear()].join('/');
    } else {
      return '';
    }
  } catch (error) {
    return ''
  }
}

export function roundOffDecimals (number, decimals=2) {
  return parseFloat(Math.round(number * 100) / 100).toFixed(decimals);
}




// WEBPACK FOOTER //
// ./src/js/utils/Utility.js